import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFoot, ModalHead, } from '@dixa/lib-shared-habla';
import * as React from 'react';
import '../../style/confirm-modal.less';
export class ConfirmModal extends React.Component {
    render() {
        const { confirm, cancel, isShown, headline, text, cancelText, confirmText, confirmVariant, confirmProps, children, } = this.props;
        if (!isShown)
            return null;
        return (_jsxs(Modal, Object.assign({ isOpen: isShown, onClose: cancel }, { children: [_jsx(ModalHead, { title: headline, onClose: cancel }), _jsxs(ModalBody, { children: [text && _jsx("div", Object.assign({ className: "confirm-modal__body" }, { children: text })), children] }), _jsx(ModalFoot, { confirmOnClick: confirm, cancelOnClick: cancel, cancelName: cancelText, confirmName: confirmText, confirmProps: Object.assign({ variant: confirmVariant || 'danger' }, confirmProps) })] })));
    }
}
ConfirmModal.defaultProps = {
    confirmProps: {},
};
